import React, { useContext, useState, useRef } from "react";
import DataTable from "react-data-table-component";
import { ReactComponent as Search } from "../../assets/search.svg";
import Tooltip from "../ToolTip/ToolTip";
import "./UserTable.css";
import AuthContext from "../../store/AuthContext";
import { useDebounce } from "../../hooks/useDebounce";
import { RotatingLines } from "react-loader-spinner";
import { resetOAuth } from "../../services/userService";
import { toast } from "react-toastify";
import Northern from "../../assets/Northern.png";
import MiddleTown from "../../assets/Middletown.png";
import Community from "../../assets/Community.png";
import authenticationIcon from "../../assets/authenticationIcon.png";

const UserTable = ({
  data,
  pending,
  setFunctionData,
  searchKeyWord,
  setSearchKeyWord,
  toggleOpen,
  toggleBulkUpdateOpen,
  setUserData,
  setIsConfirmOpen,
  toggleOpenEdit,
  setPageNumber,
  setRowsPerPage,
  sortOrderPrev,
  manageSortBy,
  rowsPerPage,
  totalRows,
  pageNumber,
  handleSearchKeyword,
}) => {
  const authCtx = useContext(AuthContext);
  const [query, setQuery] = useState(searchKeyWord);
  const [sortOrder, setSortOrder] = useState(sortOrderPrev === "desc" ? 1 : 0);
  const [clicked, setClicked] = useState(sortOrderPrev);

  const debouncedSearch = useDebounce((searchValue) => {
    console.log("Searching for:", searchValue);
    handleSearchKeyword(searchValue);
    if (inputRef.current) inputRef.current.focus();
  }, 1500); // 500ms debounce delay

  const handleInputChange = (event) => {
    const { value } = event.target;
    setQuery(value);
    debouncedSearch(value); // Call the debounced function
  };

  const handleSort = (row, sortDirection) => {
    manageSortBy(row.sortField, sortDirection);
    setSortOrder((sortOrder + 1) % 2);
    setClicked(sortDirection);
  };

  const inputRef = useRef(null);

  // const handleKeyDown = (event) => {
  //   if (event.key === "Enter") {
  //     handleSearchKeyword(query);
  //     if (inputRef.current) {
  //       inputRef.current.blur();
  //     }
  //     // Call the onSearch function when Enter is pressed
  //   }
  // };

  const columns = [
    {
      name: "Organization",
      cell: (row) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            gap: 5,
          }}
        >
          {row.organization?.imageData ? (
            <img
              style={{
                maxWidth: "80px",
                height: "auto",
                maxHeight: "50px",
                borderRadius: "10px",
                flex: 1,
              }}
              src={row.organization?.imageData}
              alt="Org"
            />
          ) : (
            <p style={{ flex: 1 }}>
              {row?.organization?.organizationName
                ? row?.organization?.organizationName
                : "Scribe.Ai"}
            </p>
          )}
        </div>
      ),
      center: true,
    },
    {
      name: (
        <div id="date-title" onClick={() => handleSort("medicalGroup")}>
          Medical Group
          {/* <spam id="sort-icon">{sortOrder === "asc" ? "▲" : "▼"}</spam> */}
        </div>
      ),
      cell: (row) => (
        <div id="date-title" className="flex items-center gap-2 cursor-pointer">
          {row?.medicalGroup === "Middletown Medical" ? (
            <img width={25} height={25} src={MiddleTown} alt="Group Icon" />
          ) : row?.medicalGroup === "Community Primary Care" ? (
            <img width={25} height={25} src={Community} alt="Group Icon" />
          ) : (
            <img width={25} height={25} src={Northern} alt="Group Icon" />
          )}
          {row.medicalGroup}
        </div>
      ),
      selector: (row) => row.medicalGroup,
      sortable: true,
      sortField: "medicalGroup",
      minWidth: "200px", // give more space
    },
    {
      name: "Name",
      selector: (row) => row.Name,
    },
    // {
    //   name: "User Id",
    //   selector: (row) => row.email,
    // },
    {
      name: "Role",
      selector: (row) => row.role,
    },
    {
      name: "AI Engine",
      selector: (row) => row.AI,
    },
    {
      name: "Status",
      cell: (row) => {
        return row.isActive ? (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            title="Status: Active"
          >
            <div class="check-box">
              <input
                type="checkbox"
                checked={true}
                onChange={(e) => {
                  e.preventDefault();
                  setIsConfirmOpen(true);
                  setFunctionData({
                    type: "ACTIVATE",
                    data: { email: row.email, status: !row.isActive },
                  });
                }}
              />
            </div>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            title="Status: Inactive"
          >
            <div class="check-box">
              <input
                type="checkbox"
                checked={false}
                onChange={(e) => {
                  e.preventDefault();
                  setIsConfirmOpen(true);
                  setFunctionData({
                    type: "ACTIVATE",
                    data: { email: row.email, status: !row.isActive },
                  });
                }}
              />
            </div>
          </div>
        );
      },
      width: "200px",
      center: true,
      sortable: false,
      // sortFunction: function sortByIsActive(user1, user2) {
      //   if (user1.isActive && !user2.isActive) {
      //     return 1;
      //   } else if (!user1.isActive && user2.isActive) {
      //     return -1;
      //   } else {
      //     return 0;
      //   }
      // },
    },
    {
      name: "Action",
      cell: (row) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 20,
          }}
        >
          <span
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: 400,
              fontSize: 12,
            }}
            onClick={() => {
              toggleOpenEdit();
              setUserData(row);
            }}
          >
            <span
              style={{
                color: "#6E75FF",
                background: "#F3F3FF",
                padding: 5,
                borderRadius: 5,
                fontSize: 14,
              }}
            >
              <Tooltip content="Edit User" direction="left">
                <ion-icon name="create-sharp"></ion-icon>
              </Tooltip>
            </span>
          </span>
          <span
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: 400,
              fontSize: 12,
            }}
            onClick={() => {
              setIsConfirmOpen(true);
              setFunctionData({ type: "DELETE", data: { id: row.id } });
            }}
          >
            <span
              style={{
                color: "#E13333",
                background: "#FFF5F5",
                padding: 5,
                borderRadius: 5,
              }}
            >
              <Tooltip content="Delete User !!" direction="left">
                <ion-icon name="trash"></ion-icon>
              </Tooltip>
            </span>
          </span>
          <span
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: 400,
              fontSize: 12,
            }}
            onClick={() => {
              setIsConfirmOpen(true);
              setFunctionData({ type: "RESET", data: { id: row.id } });
            }}
          >
            <span
              style={{
                color: "#E13333",
                background: "#FFF5F5",
                padding: 5,
                borderRadius: 5,
                display: "inline-block", // ensures padding and hover effects work properly
              }}
            >
              <Tooltip content="Reset Auth" direction="left">
                <img
                  src={authenticationIcon}
                  alt="Authentication Icon"
                  style={{ width: 16, height: 16, cursor: "pointer" }}
                />
              </Tooltip>
            </span>
          </span>
        </div>
      ),
      center: true,
      ignoreRowClick: true,
    },
  ];

  return (
    <div style={{ position: "relative", zIndex: "1" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          paddingBottom: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            width: "360px",
            height: "40px",
            background: "#F6F6F6",
            borderRadius: 5,
            justifyContent: "center",
            alignItems: "center",
            border: "1px solid rgba(126, 137, 168, 1)",
            userSelect: "none",
          }}
        >
          <svg
            onClick={() => {
              handleSearchKeyword(query);
            }}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              marginLeft: "10px",
              cursor: "pointer",
            }}
          >
            <path
              d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
              stroke="#BDBDBD"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              d="M14.0001 14.0001L11.1001 11.1001"
              stroke="#BDBDBD"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
          </svg>
          <input
            type="text"
            ref={inputRef}
            placeholder="Search Users"
            value={query}
            onChange={handleInputChange}
            style={{
              color: "rgb(126, 137, 168)",
              background: "rgb(246, 246, 246)",
              padding: "0px 10px",
            }}
          />
        </div>

        {authCtx.isAdmin && (
          <div style={{ position: "relative", display: "flex", gap: "10px" }}>
            <div
              style={{
                display: "flex",
                height: "40px",
                background: "rgba(110, 117, 255, 1)",
                borderRadius: 5,
                marginLeft: "20px",
                border: "1px solid rgba(110, 117, 255, 1)",
                justifyContent: "center",
                alignItems: "center",
                color: "white",
                cursor: "pointer",
                position: "relative",
                padding: "0 5px",
                gap: "5px",
                fontSize: "15px",
              }}
              onClick={toggleOpen}
            >
              <ion-icon
                name="person-add-outline"
                style={{ fontSize: "25px" }}
              ></ion-icon>
              Add members
            </div>
            <div
              style={{
                display: "flex",
                height: "40px",
                background: "white",
                borderRadius: 5,
                border: "1px solid rgba(110, 117, 255, 1)",
                justifyContent: "center",
                alignItems: "center",
                color: "rgba(110, 117, 255, 1)",
                cursor: "pointer",
                position: "relative",
                padding: "0 10px",
                gap: "5px",
                fontSize: "15px",
              }}
              onClick={toggleBulkUpdateOpen}
            >
              <ion-icon
                name="settings-outline"
                style={{ fontSize: "25px" }}
              ></ion-icon>
              Bulk Update AI
            </div>
          </div>
        )}
      </div>

      <DataTable
        onSort={handleSort}
        title="Users"
        paginationRowsPerPageOptions={[10, 20, 30, 40, 50, 100]}
        paginationPerPage={rowsPerPage}
        onChangeRowsPerPage={setRowsPerPage}
        onChangePage={setPageNumber}
        paginationDefaultPage={pageNumber}
        paginationServer
        paginationServerOptions={{
          persistSelectedOnPageChange: false,
          custom: true,
        }}
        onRowDoubleClicked={(row) => {
          toggleOpenEdit();
          setUserData(row);
        }}
        paginationTotalRows={totalRows}
        pagination
        columns={columns}
        data={data}
        pointerOnHover
        highlightOnHover
        // sortColumn={"medicalGroup"} // <--- tells table which column is active
        // sortDirection={sortOrder ? "desc" : "asc"}
        // sortIcon={
        //   <ion-icon
        //     name="caret-down-outline"
        //     style={{ fontSize: 12, position: "absolute", top: "40%" }}
        //   />
        // }
        progressPending={pending}
        progressComponent={
          <div id="svg-container">
            <RotatingLines
              visible={true}
              height="96"
              width="96"
              color="red"
              strokeColor="grey"
              strokeWidth="4"
              animationDuration="0.75"
              ariaLabel="rotating-lines-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        }
      />
    </div>
  );
};

export default UserTable;
